import { ImportMetaEnv } from '@/vite-env'

export const featureEnabled = (featureFlag: keyof ImportMetaEnv) => {
  return import.meta.env[featureFlag] === 'true'
}
